import React from 'react';
import { ArrowRight, Camera, MapPin, Phone, ShieldCheck, Star } from 'lucide-react';
import { business } from '../data/business';
const chips = [{
  icon: ShieldCheck,
  label: 'Licensed & insured'
}, {
  icon: Camera,
  label: 'Photo proof every job'
}, {
  icon: MapPin,
  label: '30 miles around Lincoln'
}];
export function Hero() {
  return <section id="top" className="relative w-full overflow-hidden bg-brand-navy" data-id="element-87" data-mp="4njrcfwdq5dm">
      <div className="pointer-events-none absolute inset-0 opacity-[0.07]" style={{
      backgroundImage: 'radial-gradient(circle at 1px 1px, #ffffff 1px, transparent 0)',
      backgroundSize: '22px 22px'
    }} aria-hidden="true" data-id="element-88" data-mp="1286262e70it6" />

      <div className="relative mx-auto grid max-w-7xl items-center gap-12 px-5 pb-20 pt-14 lg:grid-cols-[1.1fr_0.9fr] lg:gap-14 lg:px-8 lg:pb-24 lg:pt-20" data-id="element-89" data-mp="nb6mrsd3nlo5">
        <div data-id="element-90" data-mp="382fgpsnq3ch1">
          <div className="inline-flex items-center gap-2 rounded-full bg-brand-blue px-4 py-2 text-xs font-bold uppercase tracking-[0.15em] text-white" data-id="element-91" data-mp="381xmf1kmf8br">
            Now offering pressure washing
          </div>

          <h1 className="mt-7 font-display text-[3rem] leading-[0.88] tracking-tight text-white sm:text-7xl lg:text-[5.5rem]" data-id="element-92" data-mp="3o7vllomspvze">
            GIVE YOUR
            <br data-id="element-93" data-mp="39cfk4yjvyxsz" />
            HOUSE A
            <br data-id="element-94" data-mp="3e8wjkowjcyld" />
            <span className="relative inline-block" data-id="element-95" data-mp="3e8egb8bghk3y">
              <span className="relative z-10 text-brand-navy" data-id="element-96" data-mp="3eb8x8pv9gmsm">NEW LOOK.</span>
              <span className="absolute -inset-x-3 bottom-1 top-2 -skew-x-3 bg-brand-blue" aria-hidden="true" data-id="element-97" data-mp="30gq5d8cy11ok" />
            </span>
          </h1>

          <p className="mt-7 max-w-lg text-lg leading-relaxed text-white/75" data-id="element-98" data-mp="2qlelycqlb6ah">
            Windows, gutters and pressure washing from one local neighbor.
            {' '}{business.owner} shows up on time, works off a flat price, and sends
            you the photos when it&apos;s done.
          </p>

          <div className="mt-9 flex flex-col gap-3 sm:flex-row" data-id="element-99" data-mp="2ljz22o05f5to">
            <a href={business.phoneHref} className="inline-flex items-center justify-center gap-2 rounded-full bg-brand-blue px-7 py-4 text-base font-bold text-white shadow-lg shadow-brand-blue/30 transition-colors hover:bg-brand-blue-dark" data-id="element-100" data-mp="s2bckbltt7bh">
              <Phone className="h-5 w-5" aria-hidden="true" data-id="element-101" data-mp="ddnfu208urjy" />
              Call or Text {business.phone}
            </a>
            <a href="#quote" className="inline-flex items-center justify-center gap-2 rounded-full border-2 border-white/25 px-7 py-4 text-base font-bold text-white transition-colors hover:bg-white hover:text-brand-navy" data-id="element-102" data-mp="1azulzgc74ryf">
              Free Estimate
              <ArrowRight className="h-5 w-5" aria-hidden="true" data-id="element-103" data-mp="x1wb4kx33dno" />
            </a>
          </div>

          <ul className="mt-9 flex flex-wrap gap-x-6 gap-y-3" data-id="element-104" data-mp="3lt73mli5bhrm">
            {chips.map(chip => <li key={chip.label} className="flex items-center gap-2 text-sm font-semibold text-white/70" data-id="element-105" data-mp="3hr3q7rbx233p">
                <chip.icon className="h-4 w-4 text-brand-blue" aria-hidden="true" data-id="element-106" data-mp="1x7hw9eyk651e" />
                {chip.label}
              </li>)}
          </ul>
        </div>

        <div className="relative" data-id="element-107" data-mp="2b195sncahox4">
          <div className="relative overflow-hidden rounded-[2rem] ring-1 ring-white/15" data-id="element-108" data-mp="2b1hgq9ouqk5o">
            <img src={business.masonPhoto} alt={`${business.owner}, owner of ${business.name}, holding a squeegee outside a Lincoln home`} className="h-[24rem] w-full object-cover object-top sm:h-[30rem] lg:h-[34rem]" data-id="element-109" data-mp="2fyr8vx3ml9x7" />
          </div>

          <div className="absolute -bottom-5 -left-3 rounded-2xl bg-white px-5 py-4 shadow-xl sm:-left-6" data-id="element-110" data-mp="2tyiqs8x9jagh">
            <div className="flex items-center gap-2" data-id="element-111" data-mp="unixt5i1ugi7">
              <div className="flex" aria-hidden="true" data-id="element-112" data-mp="zlkjzzaruvxw">
                {[0, 1, 2, 3, 4].map(i => <Star key={i} className="h-4 w-4 fill-amber-400 text-amber-400" data-id="element-113" data-mp="4be0pqxbgttw" />)}
              </div>
              <span className="text-xs font-bold text-brand-navy" data-id="element-114" data-mp="3vigos9huyjzw">5.0</span>
            </div>
            <p className="mt-1 text-xs font-semibold text-brand-navy/60" data-id="element-115" data-mp="ea3fvbxtw06g">
              40+ Lincoln homes cleaned
            </p>
          </div>

          <div className="absolute -right-2 top-6 hidden rounded-2xl bg-brand-blue px-5 py-4 text-white shadow-xl sm:block" data-id="element-116" data-mp="9b8o3khvv1a7">
            <p className="font-display text-2xl leading-none tracking-tight" data-id="element-117" data-mp="3hnxxat3gd0wd">
              FREE
            </p>
            <p className="mt-1 text-xs font-bold uppercase tracking-wide" data-id="element-118" data-mp="3rftttzpw4iyh">
              Estimates
            </p>
          </div>
        </div>
      </div>
    </section>;
}